import { FC } from 'react';
import { Box, Container } from '@mui/material';
import Footer from 'src/components/Footer';
import { Outlet } from 'react-router-dom';

export const BlogLayout: FC = () => {
  return (
    <Box sx={{ flex: 1 }}>
      <Container maxWidth="lg" sx={{ mt: 3 }}>
        <Box>
          <Outlet />
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}; 